module.exports = __webpack_public_path__ + "img/img-8.111eb2eb.webp";